module.exports = __webpack_public_path__ + "21764da0d0a37d4009db7a88737b64db.svg";